import { useSelector } from 'react-redux';
import { selectTransactionFilters } from '../state/selectors';
import { TransactionFilters } from '../types';

export const useTransactionFilters = (): TransactionFilters => {
  return useSelector(selectTransactionFilters);
};
